<template>
    <div>
        
        <data-table class="p-datatable-list " :value="dataList" :total-records="quantityItens" :lazy="true"  :paginator="true"
                   :rows="quantity" dataKey="id" :rowHover="true" :selection.sync="dataSelected" :loading="loading"
                    @sort="sortAble($event)" @page="changePage($event)">
            <template #header v-if="tableHeader">
                <div class="table-header">
                    {{ $t(tableHeader) }}
                </div>
            </template>
            <template #empty>
                {{emptyTable ? $t(emptyTable) : $t('dataTable.no-result-found')}}
            </template>
            <template #loading>
                {{loadingMessage ? $t(loadingMessage) : $t('dataTable.loading-data')}}
            </template>
            <column v-for="(column, index) in columns" :field="column.field" :header="$t(column.header)" :sortable="column.sortable" :key="index" :headerStyle="column.style"
                    @click="sortAble(column.imageLabel || column.field)" :sortField="column.imageLabel || column.field" :filterField="column.imageLabel || column.field">
                <template #body="slotProps">
                    <template v-if="column.type === 'boolean'">
                        <span class="responsive-header">{{$t(column.header)}}: </span><span class="p-tag" :class="[{'p-tag-success': slotProps.data[column.field], 'p-tag-danger': !slotProps.data[column.field]}]">{{slotProps.data[column.field] ? $t("dataTable.boolean-true") : $t("dataTable.boolean-false")}}</span>
                    </template>
                    <template v-else-if="column.type === 'tag'">
                        <span class="responsive-header">{{$t(column.header)}}: </span><span class="p-tag" :class="column.colors[slotProps.data[column.field]]">{{column.function ? column.function(slotProps.data[column.field]) : slotProps.data[column.field]}}</span>
                    </template>
                    <template v-else-if="column.type === 'image'">
                        <image-from-server :src="slotProps.data[column.field]" width="40" style="vertical-align: middle; border-radius: 50%;" :alt="slotProps.data[column.imageLabel]" />
                        <span style="margin-left: .5em; vertical-align: middle" class="image-text">{{slotProps.data[column.imageLabel]}}</span>
                    </template>
                    <template v-else-if="column.type === 'date-time'">
                        <span class="responsive-header">{{$t(column.header)}}: </span><span v-if="slotProps.data[column.field]">{{$d(new Date(slotProps.data[column.field]), 'long')}}</span>
                    </template>
                    <template v-else-if="column.type === 'money'">
                      <span class="responsive-header">{{$t(column.header)}}: </span><span v-if="slotProps.data[column.field]">{{$n(slotProps.data[column.field], 'currency')}}</span>
                    </template>
                    <template v-else-if="column.type === 'date'">
                        <span class="responsive-header">{{$t(column.header)}}: </span><span v-if="slotProps.data[column.field]">{{$d(new Date(slotProps.data[column.field]), 'short')}}</span>
                    </template>
                    <template v-else-if="column.type === 'function'">
                        <span class="responsive-header">{{$t(column.header)}}: </span><span v-if="slotProps.data[column.field]">{{column.function(slotProps.data[column.field])}}</span>
                    </template>
                    <template v-else-if="column.type === 'actions'">
                        <template v-for="(action, actionIndex) in column.actions">
                            <a v-if="action.type === 'link'" class="p-input-icon-left cursor-pointer" :href="`${action.link}/${slotProps.data.id}`" :key="actionIndex">
                                <i v-if="action.icon" :class="action.icon" :title="$t(action.title)"/>
                                <ancestryline-data-table-field-display pClass="image-text" :column="column" :data="slotProps.data" :key="actionIndex"/>
                            </a>
                            <a v-else-if="action.type === 'protocolLink'" class="p-input-icon-left cursor-pointer" :href="`#/protocol/${slotProps.data.id}`" :key="actionIndex">
                                <i :class="action.icon" :title="$t(action.title)"/>
                                <ancestryline-data-table-field-display pClass="image-text" :column="column" :data="slotProps.data" :key="actionIndex"/>
                            </a>
                            <a v-else-if="action.type === 'clientLink'" class="p-input-icon-left cursor-pointer" :href="`#/client/${slotProps.data.id}/details`" :key="actionIndex">
                                <i :class="action.icon" :title="$t(action.title)"/>
                                <ancestryline-data-table-field-display pClass="image-text" :column="column" :data="slotProps.data" :key="actionIndex"/>
                            </a>
                            <a v-else-if="action.type === 'mainClientLink'" class="p-input-icon-left cursor-pointer" :href="`#/client/${slotProps.data.mainClientId}/details`" :key="actionIndex">
                                <i :class="action.icon" :title="$t(action.title)"/>
                                <ancestryline-data-table-field-display pClass="image-text" :column="column" :data="slotProps.data" :key="actionIndex"/>
                            </a>
                            <a v-else-if="action.type === 'functionLink'" class="p-input-icon-left cursor-pointer" :key="actionIndex" @click.prevent="actionFunction(action, slotProps)">
                                  <i :class="action.icon" :title="$t(action.title)"/>
                                  <ancestryline-data-table-field-display pClass="image-text" :column="column" :data="slotProps.data" :key="actionIndex"/>
                              </a>
                            <a v-else class="p-input-icon-left cursor-pointer" style="width: 25px;" :key="actionIndex" @click.prevent="actionFunction(action, slotProps)">
                                <i :class="action.icon" :title="$t(action.title)"/>
                                <ancestryline-data-table-field-display pClass="image-text" :column="column" :data="slotProps.data" :key="actionIndex"/>
                            </a>
                        </template>
                    </template>
                    <template v-else>
                        <span class="responsive-header">{{$t(column.header)}}: </span><ancestryline-data-table-field-display :column="column" :data="slotProps.data"/>
                    </template>
                    <hr class="responsive-line" v-if="index + 1 === columns.length"/>
                </template>
            </column>
        </data-table>

    </div>

</template>

<script>
    import ImageFromServer from "@/components/image/ImageFromServer";
    import AncestrylineDataTableFieldDisplay from "@/components/table/AncestrylineDataTableFieldDisplay";
    export default {
        name: "AncestrylineDataTable",
        components: {AncestrylineDataTableFieldDisplay, ImageFromServer},
        props: {
            dataFunction: {
                type: Function,
                default: async () => {}
            },
            columns: {
                default: []
            },
            quantityRows: {
                type: Number,
                default: 10
            },
            tableHeader: {
                type: String,
                default: null,
            },
            loadingMessage: {
                type: String,
                default: null,
            },
            emptyTable: {
                type: String,
                default: null,
            },
            defaultFilter: {
              default: async () => {return {}}
            },
            sortColumn: {
                type: String,
                default: null,
            },
            sortDirection: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                dataList: null,
                dataSelected: null,
                filters: {},
                loading: true,

                sort: null,
                direction: null,

                page: 0,
                total: 0,
                quantity: this.quantityRows,
                pages: [],
                quantityItens: 0,
            }
        },

        async mounted() {
            this.filters = this.defaultFilter;
            if (this.sortColumn && this.sortDirection) {
                this.sort = this.sortColumn;
                this.direction = this.sortDirection;
            }
            await this.loadPage();
        },

        methods:{

            async changePage(pageEvent){
                await this.loadPage(pageEvent.page + 1);
            },

            async loadPage(page){
                const result = await this.dataFunction(this.sort, this.direction, page || this.page, this.quantity, this.filters);
                this.dataList = result.page;
                this.quantityItens = result.quantity;
                this.loading = false;
            },

            async sortAble(eventSort){
                this.sort = eventSort.sortField;
                this.direction = eventSort.sortOrder === 1 ? 'asc' : 'desc';
                await this.loadPage();
            },

            async actionFunction(action, slotProps){
              const response = await action.function(slotProps.data, this.dataList)
              if(action.refreshList){
                this.$set(this,'dataList', response);
              }
            },

        }

    }
</script>

<style lang=scss scoped>

    .table-header {
        display: flex;
        justify-content: space-between;
    }

    .p-datatable-list .p-datatable-tbody > tr > td .p-column-title {
        display: none;
    }

    @media screen and (max-width: 960px) {
        /deep/ .p-datatable {
            &.p-datatable-list {
                .p-datatable-thead > tr > th,
                .p-datatable-tfoot > tr > td {
                    display: none !important;
                }
                .p-datatable-tbody > tr {
                    > td {
                        text-align: left;
                        display: block;
                        border: 0 none !important;
                        width: 100% !important;
                        float: left;
                        clear: left;
                        border: 0 none;
                        .p-column-title {
                            padding: .4rem;
                            min-width: 30%;
                            display: inline-block;
                            margin: -.4rem 1rem -.4rem -.4rem;
                            font-weight: bold;
                        }
                        padding: 0.5rem 1rem !important;;
                    }
                }
            }
        }
        .responsive-header {
            display: initial !important;
        }
        .responsive-line {
            margin-top: 1.5rem;
            display: flex !important;
        }
    }

    .responsive-header {
        font-weight: 500;
        display: none;
    }

    .responsive-line {
        display: none;
    }

    .p-datatable-loading-overlay {
        background-color: transparent !important;
    }

</style>